var map = {
	"./book1.jpg": 967,
	"./book2.jpg": 8,
	"./book3.jpg": 461,
	"./book4.jpg": 110,
	"./book5.jpg": 192,
	"./book6.jpg": 356,
	"./book7.jpg": 881,
	"./book8.jpg": 2
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;